import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';
import { withTranslation } from 'react-i18next';

import styles from './NoBuildings.scss';
import { changeFilters } from 'actions/search';
import nothingFound from 'assets/images/nothingfound.png';


class NoBuildings extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { dispatch, location, history } = this.props;
    const { pathname } = location;
    const path = `${pathname}`;
    history.push(path);
    dispatch(changeFilters(null, { reset: true }));
  }

  render() {
    const { t } = this.props;
    const {
      className, classNameInfo, text, title,
      buttonText = t('components.buildings.noBuildings.startNewSearch'),
      onClick
    } = this.props;

    return (
      <div className={cn(styles.NoBuildings)}>
        <div className={cn(styles.Rectangle, className)}>
          <img className={cn(styles.Image)} src={nothingFound} alt="nothing found" />
          <div className={cn(styles.Info, classNameInfo)}>
            <span className={cn(styles.InfoTitle)}>
              {title || t('components.buildings.noBuildings.notFound')}
            </span>
            {
              text ||
              <span
                className={cn(styles.InfoSubTitle)}
                dangerouslySetInnerHTML={{ __html: t('components.buildings.noBuildings.notFoundFull') }}
              />
            }
            <button className={cn(styles.Button)} onClick={onClick || this.onClick}>
              { buttonText }
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withRouter(NoBuildings));



// WEBPACK FOOTER //
// ./src/components/Buildings/NoBuildings/NoBuildings.js